module.exports = __webpack_public_path__ + "img/appltCourse-img8.53af8797.png";